export const prepareForSave = (obj) => {
    // remove __typename, createdAt and updatedAt fields
    // if there is a nested object, call prepareForSave on that object
    // if there is an array of objects, call prepareForSave on each object
    if (!obj)
        return null;
    if (Array.isArray(obj)) {
        return obj.map((item) => {
            if (typeof item === 'object') {
                return prepareForSave(item);
            }
            return item;
        });
    }
    if (typeof obj === 'object') {
        const newObj = Object.entries(obj).reduce((acc, [key, value]) => {
            if (key === '__typename' || key === 'createdAt' || key === 'updatedAt') {
                return acc;
            }
            if (typeof value === 'object') {
                return { ...acc, [key]: prepareForSave(value) };
            }
            if (Array.isArray(value)) {
                return { ...acc, [key]: prepareForSave(value) };
            }
            return { ...acc, [key]: value };
        }, {});
        return newObj;
    }
    return obj;
};
